import { Link, useLocation } from "react-router-dom"; // Updated to include useLocation
import { RiInboxArchiveFill } from "react-icons/ri";
import { initFlowbite } from "flowbite";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useSidebar } from "../context/SidebarOpenContext";
import { Modal } from "flowbite-react";
import ThemeSetting from "../component/setting/ThemeSetting";
import { TbCircleLetterRFilled } from "react-icons/tb";
import { BsStack } from "react-icons/bs";
import { IoPeopleSharp } from "react-icons/io5";
import { CgMenuGridR } from "react-icons/cg";
import { HiOutlineArrowPath } from "react-icons/hi2"; // Added new icon for Stock Usage

function Sidebar() {
   const location = useLocation(); // New line added

   useEffect(() => {
      initFlowbite();
   }, []);

   const [IsSettingModal, setIsSettingModal] = useState(false);

   const { isSidebarOpen, toggleSidebar } = useSidebar();

   const role = sessionStorage.getItem('role');
   // console.log(role);

   const [openDropdown, setOpenDropdown] = useState(null);

   // New useEffect added to keep dropdown open based on URL
   useEffect(() => {
      const path = location.pathname;
      if (path === "/customer" || path === "/vendor" || path === "/staff") {
         setOpenDropdown('one');
      } else if (path === "/marker" || path === "/style" || path === "/colour" || path === "/line") {
         setOpenDropdown('two');
      } else if (path === "/rawmaterial" || path === "/fabric") {
         setOpenDropdown('three');
      } else if (path === "/purchasebill" || path === "/issue-entries") {
         setOpenDropdown('usage');
      }
   }, [location]);

   const toggleDropdown = (dropdownName) => {
      setOpenDropdown(prev =>
         prev === dropdownName ? null : dropdownName
      );
   };

   return (
      <>
         <nav className="fixed top-0 z-50 w-full bg-white border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700 shadow ">
            <div className="px-3 py-3 lg:px-5 lg:pl-3">
               <div className="flex items-center justify-between">
                  <div className="flex items-center justify-start rtl:justify-end">
                     <button onClick={toggleSidebar} type="button" className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg  hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600">
                        <span className="sr-only">Open sidebar</span>
                        <svg className="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                           <path clip-rule="evenodd" fill-rule="evenodd" d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"></path>
                        </svg>
                     </button>
                     <div className="flex ms-2 md:me-24">
                        {/* <img src="https://flowbite.com/docs/images/logo.svg" className="h-8 me-3" alt="FlowBite Logo" /> */}
                        <span className="self-center text-xl font-semibold sm:text-2xl text-sidebar-color whitespace-nowrap dark:text-white">Garments</span>
                     </div>
                  </div>
                  <div className="flex items-center">
                     <div className="flex items-center ms-3">
                        <div>
                           <button type="button" className="flex text-sm bg-gray-800 rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600" aria-expanded="false" data-dropdown-toggle="dropdown-user">
                              <span className="sr-only">Open user menu</span>
                              {/* <img className="w-8 h-8 rounded-full" src="https://flowbite.com/docs/images/people/profile-picture-5.jpg" alt="user photo" /> */}
                              <img
                                 className="w-10 h-10 rounded-full "
                                 src={require("../images/profile.png")}
                                 alt="User photo"
                              />
                           </button>
                        </div>
                        <div className="z-50 hidden my-4 text-base list-none bg-white divide-y divide-gray-100 rounded shadow dark:bg-gray-700 dark:divide-gray-600" id="dropdown-user">
                           <div className="px-4 py-3" role="none">
                              <p className="text-sm text-gray-900 dark:text-white text-center" role="none">
                                 {sessionStorage.getItem('staff_name')}
                              </p>
                              <p className="text-xs text-center italic font-medium text-gray-400 truncate dark:text-gray-300" role="none">
                                 {sessionStorage.getItem('role')}
                              </p>
                           </div>
                           <ul className="py-1" role="none">
                              {(sessionStorage.getItem('role') === "super_admin" || sessionStorage.getItem('role') === "FM") && (
                                 <li>
                                    <Link to="/dashboard" className="block px-4 py-2 text-sm text-gray-700 hover:bg-content-bg dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white">
                                       Dashboard
                                    </Link>

                                 </li>
                              )}
                              <li>
                                 {/* <div onClick={() => setIsSettingModal(true)} className="block px-4 py-2 text-sm text-gray-700 hover:bg-content-bg dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">Settings</div> */}
                              </li>
                              <li>
                                 {/* <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-content-bg dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">Earnings</a> */}
                              </li>
                              <li>
                                 <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-content-bg dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">Sign out</a>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </nav>

         <aside
            // id="logo-sidebar"
            className={`fixed top-0 left-0 z-40 w-64 h-screen pt-20 transition-transform ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"
               } bg-sidebar-color border-r border-gray-200 dark:bg-gray-800 dark:border-gray-700`}
            aria-label="Sidebar"
         >
            <div className="h-full px-3 pb-4 overflow-y-auto bg-sidebar-color dark:bg-gray-800">
               <ul className="space-y-2 font-medium"  >
                  {(sessionStorage.getItem('role') === "super_admin" || sessionStorage.getItem('role') === "FM") && (
                     <li >
                        <Link to="/dashboard">
                           <a href="#" className="flex items-center p-2  rounded-lg dark:text-white hover:bg-content-bg dark:hover:bg-gray-700 group">
                              <svg className="w-5 h-5 text-icon-color transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 21">
                                 <path d="M16.975 11H10V4.025a1 1 0 0 0-1.066-.998 8.5 8.5 0 1 0 9.039 9.039.999.999 0 0 0-1-1.066h.002Z" />
                                 <path d="M12.5 0c-.157 0-.311.01-.565.027A1 1 0 0 0 11 1.02V10h8.975a1 1 0 0 0 1-.935c.013-.188.028-.374.028-.565A8.51 8.51 0 0 0 12.5 0Z" />
                              </svg>
                              <span className="ms-3  text-white group-hover:text-gray-900">Dashboard</span>
                           </a>
                        </Link>
                     </li>)}
                  {sessionStorage.getItem('role') == 'super_admin' &&
                     <>
                        <ul>
                           {/* Dropdown One */}
                           <li>
                              <button
                                 type="button"
                                 onClick={() => toggleDropdown('one')}
                                 className="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-content-bg dark:text-white dark:hover:bg-gray-700"
                              >

                                 <IoPeopleSharp className="flex-shrink-0 w-5 h-5 text-icon-color transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white" />
                                 <span className="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap text-white group-hover:text-gray-900">User Records</span>
                                 <svg className="w-3 h-3 text-white group-hover:text-gray-900" fill="none" viewBox="0 0 10 6">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                                 </svg>
                              </button>
                              {openDropdown === 'one' && (
                                 <ul className="py-2 space-y-2">
                                    <li><Link to="/customer" className="block p-2 text-white hover:text-gray-900 pl-11 rounded-lg hover:bg-content-bg dark:hover:bg-gray-700">Customer</Link></li>
                                    <li><Link to="/vendor" className="block p-2 text-white hover:text-gray-900 pl-11 rounded-lg hover:bg-content-bg dark:hover:bg-gray-700">Vendor</Link></li>
                                    <li><Link to="/staff" className="block p-2 text-white hover:text-gray-900 pl-11 rounded-lg hover:bg-content-bg dark:hover:bg-gray-700">Staff</Link></li>
                                 </ul>
                              )}
                           </li>

                           {/* Dropdown Two */}
                           <li>
                              <button
                                 type="button"
                                 onClick={() => toggleDropdown('two')}
                                 className="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-content-bg dark:text-white dark:hover:bg-gray-700"
                              >
                                 <CgMenuGridR className="flex-shrink-0 w-5 h-5 text-icon-color transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white" />
                                 <span className="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap text-white group-hover:text-gray-900">Master Records</span>
                                 <svg className="w-3 h-3 text-white group-hover:text-gray-900" fill="none" viewBox="0 0 10 6">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                                 </svg>
                              </button>
                              {openDropdown === 'two' && (
                                 <ul className="py-2 space-y-2">
                                    <li><Link to="/marker" className="block p-2 text-white hover:text-gray-900 pl-11 rounded-lg hover:bg-content-bg dark:hover:bg-gray-700">Size</Link></li>
                                    <li><Link to="/style" className="block p-2 text-white hover:text-gray-900 pl-11 rounded-lg hover:bg-content-bg dark:hover:bg-gray-700">Style</Link></li>
                                    <li><Link to="/colour" className="block p-2 text-white hover:text-gray-900 pl-11 rounded-lg hover:bg-content-bg dark:hover:bg-gray-700">Colour</Link></li>
                                    <li><Link to="/line" className="block p-2 text-white hover:text-gray-900 pl-11 rounded-lg hover:bg-content-bg dark:hover:bg-gray-700">Line</Link></li>
                                 </ul>
                              )}
                           </li>

                           {/* Dropdown Three */}
                           <li>
                              <button
                                 type="button"
                                 onClick={() => toggleDropdown('three')}
                                 className="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-content-bg dark:text-white dark:hover:bg-gray-700"
                              >

                                 <BsStack className="flex-shrink-0 w-5 h-5 text-icon-color transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white" />
                                 <span className="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap text-white group-hover:text-gray-900">Stock Records</span>
                                 <svg className="w-3 h-3 text-white group-hover:text-gray-900" fill="none" viewBox="0 0 10 6">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                                 </svg>

                              </button>
                              {openDropdown === 'three' && (
                                 <ul className="py-2 space-y-2">
                                    <li><Link to="/rawmaterial" className="block p-2 text-white hover:text-gray-900 pl-11 rounded-lg hover:bg-content-bg dark:hover:bg-gray-700">Trims</Link></li>
                                    <li><Link to="/fabric" className="block p-2 text-white hover:text-gray-900 pl-11 rounded-lg hover:bg-content-bg dark:hover:bg-gray-700">Fabric</Link></li>
                                    <li><Link to="/allstock" className="block p-2 text-white hover:text-gray-900 pl-11 rounded-lg hover:bg-content-bg dark:hover:bg-gray-700">All Stock</Link></li>
                                 </ul>
                              )}
                           </li>
                           {/* <li>
                              <button
                                 type="button"
                                 onClick={() => toggleDropdown('stock_maint')}
                                 className="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-content-bg dark:text-white dark:hover:bg-gray-700"
                              >
                                 <RiInboxArchiveFill className="flex-shrink-0 w-5 h-5 text-icon-color transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white" />
                                 <span className="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap text-white group-hover:text-gray-900">Stock Maintenance</span>
                                 <svg className={`w-3 h-3 text-white group-hover:text-gray-900 transition-transform ${openDropdown === 'stock_maint' ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 10 6">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                                 </svg>
                              </button>
                              {openDropdown === 'stock_maint' && (
                                 <ul className="py-2 space-y-2">
                                    <li><Link to="/inventory-trims" className="block p-2 text-white hover:text-gray-900 pl-11 rounded-lg hover:bg-content-bg dark:hover:bg-gray-700">Trims Inventory</Link></li>
                                    <li><Link to="/inventory-fabrics" className="block p-2 text-white hover:text-gray-900 pl-11 rounded-lg hover:bg-content-bg dark:hover:bg-gray-700">Fabric Inventory</Link></li>
                                 </ul>
                              )}
                           </li> */}

                           <li>
                              <Link to="/stock-usage">
                                 <a href="#" className="flex items-center p-2 rounded-lg dark:text-white hover:bg-content-bg dark:hover:bg-gray-700 group">
                                    <RiInboxArchiveFill className="flex-shrink-0 w-5 h-5 text-icon-color transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" />
                                    <span className="ms-3 text-white group-hover:text-gray-900">Stock Usage</span>
                                 </a>
                              </Link>
                           </li>
                        </ul>
                     </>
                  }
                  <li >
                     <Link to="/order">
                        <a href="#" className="flex items-center p-2  rounded-lg dark:text-white hover:bg-content-bg dark:hover:bg-gray-700 group">
                           <RiInboxArchiveFill className="flex-shrink-0 w-5 h-5 text-icon-color transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" />
                           <span className="ms-3  text-white group-hover:text-gray-900">Order</span>
                        </a>
                     </Link>
                  </li>
                  {sessionStorage.getItem('role') == "super_admin" &&
                     <li >
                        <Link to="/request">
                           <a href="#" className="flex items-center p-2  rounded-lg dark:text-white hover:bg-content-bg dark:hover:bg-gray-700 group">
                              <TbCircleLetterRFilled className="flex-shrink-0 w-5 h-5 text-icon-color transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" />
                              <span className="ms-3  text-white group-hover:text-gray-900">Requests</span>
                           </a>
                        </Link>
                     </li>
                  }
                  {(sessionStorage.getItem('role') === "super_admin" || sessionStorage.getItem('role') === "Accountant") && (
                     <li>
                        <Link to="/billing">
                           <a href="#" className="flex items-center p-2 rounded-lg dark:text-white hover:bg-content-bg dark:hover:bg-gray-700 group">
                              <TbCircleLetterRFilled className="flex-shrink-0 w-5 h-5 text-icon-color transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" />
                              <span className="ms-3 text-white group-hover:text-gray-900">Billing</span>
                           </a>
                        </Link>
                     </li>
                  )}
               </ul>
            </div>
         </aside>

         <Modal show={IsSettingModal} size="lg" onClose={() => setIsSettingModal(false)}>
            <Modal.Header>Settings</Modal.Header>
            <Modal.Body>
               <ThemeSetting />
            </Modal.Body>
         </Modal>
      </>
   );
};
export default Sidebar;